import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";

import PerformanceIndicator from "../../../Micro/PerformanceIndicator.js";
import AudienceResultsBoard from "../../../Micro/AudienceResultsBoard.js";

//Images
import info from "../../../Global/Icons/info.svg";

const multiple = nota.global.multiple;

const StyledAudienceResultsBlock = styled(NanoFlex)`
  .dropdown-content {
    left: unset;
    transform: translate(0%);
    right: -17.5px;
    margin: 12px;
  }

  .tooltipWrapper {
    min-width: 300px;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: ${multiple + "px"}; /* 8px */
    position: relative;
    cursor: default;
    &:after,
    &:before {
      bottom: 100%;
      right: 5px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: ${nota.color.neutral.white};
      border-width: 8px;
      margin-right: 0px;
    }
    &:before {
      border-color: rgba(0, 168, 225, 0);
      border-bottom-color: ${nota.color.neutral.NeuTwo};
      border-width: 9px;
      margin-right: -1px;
    }
    .optionLine {
      padding: ${multiple + "px"}; /* 8px */
      border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
      .performanceWrapper {
        margin-right: ${multiple * 2 + "px"}; /*16px */
      }
      p {
        letter-spacing: 1px;
        font-size: 12px;
        width: 100%;
      }

      &:last-child {
        border-bottom: 0;
      }
      &:hover {
        background-color: ${nota.color.neutral.NeuFour};
      }
    }
    .specialOption {
      p {
        text-transform: uppercase;
        color: ${nota.color.main.default};
      }
    }
  }

  .audienceResultsTable {
    .titleContainer {
      overflow: unset;
    }
  }

  @media only screen and (max-width: 345px) {
    .tooltipWrapper {
      min-width: 200px;
    }
  }
`;

export class AudienceResultsBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.audienceResults) return null;

    return (
      <StyledAudienceResultsBlock className="rowContainer">
        <WrapperList simple className="audienceResultsTable">
          <TitleCard
            simpleTitle={this.translation.card.audienceResults.title}
            secTitle={this.props.card.sourceDescription}
            icon={info}
            iconHoverContent={
              <NanoFlex>
                <NanoFlex className="tooltipWrapper" flexDirection={"column"}>
                  <NanoFlex className="optionLine">
                    <div className="performanceWrapper">
                      <PerformanceIndicator color={"green"} />
                    </div>
                    <Type.p>{this.translation.card.audienceResults.performance.green}</Type.p>
                  </NanoFlex>
                  <NanoFlex className="optionLine">
                    <div className="performanceWrapper">
                      <PerformanceIndicator color={"yellow"} />
                    </div>
                    <Type.p>{this.translation.card.audienceResults.performance.yellow}</Type.p>
                  </NanoFlex>
                  <NanoFlex className="optionLine">
                    <div className="performanceWrapper">
                      <PerformanceIndicator color={"red"} />
                    </div>
                    <Type.p>{this.translation.card.audienceResults.performance.red}</Type.p>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            }
          />
          <AudienceResultsBoard data={this.props.audienceResults} />
        </WrapperList>
      </StyledAudienceResultsBlock>
    );
  }
}

//Set default props
AudienceResultsBlock.defaultProps = {
  card: {},
};

export default AudienceResultsBlock;

// --- // Documentation // --- //
/*
  import AudienceResultsBlock from './../Partial/AudienceResultsBlock.js';
  
  <AudienceResultsBlock/>
  */
